<template>
  <b-alert v-model="showAlert" variant='error' dismissible class="alert error-alert">
    {{ message }}
  </b-alert>
</template>

<style scoped>

.alert {
  position: fixed;
  bottom: 1%;
  z-index: 2000;
  left: 3%;
  right: 3%;
}

.error-alert {
  color: #721c24 !important;
  background-color: #f8d7da !important;
  border-color: #e0afb4  !important; /*  #f5c6cb !important; */
}

</style>

<script>

import EventBus from '../EventBus';

export default {
  name: 'ErrorAlert',
  components: {},
  data () {
    return {
      message: '',
      showAlert: false
    };
  },
  computed: {},
  mounted () {
    EventBus.$on('show-error-alert', this.showErrorAlert);
  },
  beforeDestroy () {
    EventBus.$off('show-error-alert', this.showErrorAlert);
  },
  methods: {
    showErrorAlert: function (message) {
      this.message = message;
      this.showAlert = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Alerts/ErrorAlert.vue